module.exports = __webpack_public_path__ + "assets/images/search-chevroneb3d1ef15a59a9144e0c6bdbd33ba2df.svg";